<template>
  <div class="main-con el-main">
    <router-view />
  </div>
</template>

<script>
    export default {
        name: "CustomerApplying"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dealer/CustomerApplying.vue